/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Unit_AmountInputs */

const en_admin_discounts_unit_amount = /** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed Amount`)
};

const de_admin_discounts_unit_amount = /** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fester Betrag`)
};

const es_admin_discounts_unit_amount = /** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe fijo`)
};

const fr_admin_discounts_unit_amount = /** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant fixe`)
};

const nl_admin_discounts_unit_amount = /** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vast bedrag`)
};

/** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */
const it_admin_discounts_unit_amount = en_admin_discounts_unit_amount;

/** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */
const pt_br2_admin_discounts_unit_amount = en_admin_discounts_unit_amount;

/** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */
const pl_admin_discounts_unit_amount = en_admin_discounts_unit_amount;

/** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */
const hu_admin_discounts_unit_amount = en_admin_discounts_unit_amount;

/** @type {(inputs: Admin_Discounts_Unit_AmountInputs) => LocalizedString} */
const ro_admin_discounts_unit_amount = en_admin_discounts_unit_amount;

/**
* | output |
* | --- |
* | "Fixed Amount" |
*
* @param {Admin_Discounts_Unit_AmountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_unit_amount = /** @type {((inputs?: Admin_Discounts_Unit_AmountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Unit_AmountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_unit_amount(inputs)
	if (locale === "de") return de_admin_discounts_unit_amount(inputs)
	if (locale === "es") return es_admin_discounts_unit_amount(inputs)
	if (locale === "fr") return fr_admin_discounts_unit_amount(inputs)
	if (locale === "nl") return nl_admin_discounts_unit_amount(inputs)
	if (locale === "it") return it_admin_discounts_unit_amount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_unit_amount(inputs)
	if (locale === "pl") return pl_admin_discounts_unit_amount(inputs)
	if (locale === "hu") return hu_admin_discounts_unit_amount(inputs)
	return ro_admin_discounts_unit_amount(inputs)
});
export { admin_discounts_unit_amount as "admin.discounts.unit_amount" }